<template>
    <div class="cms-offer__content-block cms-offer__content-block--two-column-content">
        <div class="cms-content">
            <div class="container">
                <div class="rd-card rd-card--border-top is-card">
                    <div class="cms-content-multi-column-grid cms-content-multi-column-grid--two-columns">
                        <a href="/service/careplan">
                            <picture class="cms-content-multi-column-grid__media">
                                <source srcset="/images/events/2023/car-care-plan/car-care-plan.webp" type="image/webp">
                                <img srcset="/images/events/2023/car-care-plan/car-care-plan.jpg"
                                    alt="Stellantis &amp;You UK Careplan"
                                    class="img-responsive center-block cms-content-rounded-image cms-content-rounded-image--cover">
                            </picture>
                        </a>
                        <div class="cms-content-multi-column-grid__text">
                            <h2 class="cms-content-heading">
                                Protect your used car with a Stellantis &You UK Careplan
                            </h2>
                            <p>
                                Enjoy all the essential elements of owning a vehicle, wrapped into one simple, inflation
                                protected, fixed price subscription.
                            </p>

                            <p>
                                Our <a href="/used-vehicles/careplan">Stellantis &You UK Careplan</a> is the perfect way to look after your vehicle and give
                                yourself reassurance. With 3 levels of cover to choose from with our top package
                                including routine servicing, an annual MOT, roadside assistance and lifetime warranty,
                                you can select the package that suits your needs for worry-free motoring.
                            </p>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "../../../../sass/redesign/variables";

.cms-content-heading {
    color: $dark-blue;
}

.cms-content {
    padding-top: 45px;
    padding-bottom: 45px;
}

.cms-content-multi-column-grid {
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr;

    &__media {
        order: 0;

        @media (min-width: $screen-md) {
            order: unset;
        }
    }

    &__text {
        order: 1;

        @media (min-width: $screen-md) {
            order: unset;
        }
    }

    &__content {
        padding: 22px;
        padding-bottom: 0px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &--no-padding {
            padding: 0px;
        }
    }

    &__card-content {
        padding: 22px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &--no-padding {
            padding: 0px;
        }
    }

    &--two-columns {
        gap: 30px;

        @media (min-width: $screen-md) {
            gap: 47px;
            grid-template-columns: repeat(2, 1fr);
        }
    }

    &--three-columns {
        gap: 18px;

        @media (min-width: $screen-sm) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media (min-width: $screen-md) {
            grid-template-columns: repeat(3, 1fr);
        }
    }
}

.cms-content-rounded-image {
    border-radius: $default-card-border-radius;
    max-height: 180px;
    width: 100%;

    @media (min-width: $screen-sm) {
        max-height: 340px;
    }

    &--cover {
        object-fit: cover;
    }
}

.cms-content-offset-image {
    transform: translate3d(0, -75px, 0);
    margin-bottom: -75px;
}

.cms-content-rounded-video iframe {
    border-radius: $default-card-border-radius;
    height: 180px;
    width: 100%;

    @media (min-width: $screen-sm) {
        height: 340px;
    }
}

.is-card.bg--rd-stellantis-pop-purple {
    color: #ffffff;

    .cms-content-heading {
        color: #ffffff;
    }
}</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedDetails/CarCarePlan.vue